import { render } from "./InputView.vue?vue&type=template&id=094cb566"
import script from "./InputView.vue?vue&type=script&lang=js"
export * from "./InputView.vue?vue&type=script&lang=js"

import "./InputView.vue?vue&type=style&index=0&id=094cb566&lang=css"

import exportComponent from "C:\\Work\\huabiao-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__